import { render } from "./App.vue?vue&type=template&id=1e674792"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1e674792&lang=scss"

import exportComponent from "/home/ubuntu/chatbot/chatbot_web/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__